























import { Component, Vue } from 'vue-property-decorator'
import { FillInfoItemOfForm, OperationItemType, OptionItemType } from '../../types/type'
import { getAllFatherNodeForTree, findItemForTree, disposeFillInfoToParamsForCM } from '../../utils/toolsForCommon'
import { CommonModule, UserModule } from '../../store'
@Component({
  name: 'AddOrUpdateEarlyWarning',
  components: {
    'form-module': () => import('../../components/common/formModule.vue')
  }
})
export default class AddOrUpdateEarlyWarning extends Vue {
  public loading = false
  public headerOperationListForAddOrUpdateAtSchoolStudents: Array<OperationItemType> = [
    {
      title: "<span class='el-icon-caret-left m_r5'></span>返回",
      key: 'back',
      type: 'primary',
      size: ''
    }
  ]
  public bottomOperationListForAddOrUpdateAtSchoolStudents: Array<OperationItemType> = [
    {
      title: `保存`,
      key: 'save',
      type: 'success',
      size: ''
    }
  ]
  // 枚举选项：
  public optionsForType: Array<OptionItemType> = [
    {
      name: '食材支出占比',
      value: 1
    },
    {
      name: '食材单价',
      value: 2
    },
    {
      name: '自制凭证',
      value: 3
    },
    {
      name: '日常预警',
      value: 4
    },
    {
      name: '流水',
      value: 5
    }
  ]
  public optionsForSubType: Array<OptionItemType> = [
    {
      name: '陪餐',
      value: 1
    },
    {
      name: '培训',
      value: 2
    },
    {
      name: '留样',
      value: 3
    },
    {
      name: '消杀',
      value: 4
    }
  ]
  public fillInfoList: Array<FillInfoItemOfForm> = [
    {
      title: '预警类型',
      type: 'select',
      key: 'type',
      value: '',
      placeholder: '请选择预警类型',
      selectOptions: [],
      isNecessary: true
    },
    {
      title: '日常预警具体类型',
      type: 'select',
      key: 'subType',
      value: '',
      placeholder: '请选择日常预警具体类型',
      isNecessary: true,
      hide: true
    },
    // {
    //   title: '年',
    //   type: 'text',
    //   key: 'comPosition',
    //   value: '',
    //   placeholder: '请输入职务',
    //   isNecessary: true
    // },
    // {
    //   title: '月',
    //   type: 'photoForList',
    //   key: 'picture',
    //   value: '',
    //   placeholder: '请上传图片',
    //   isNecessary: true,
    //   imgList: [],
    //   explainText: '说明：可上传多张图片'
    // },
    // {
    //   title: '日',
    //   type: 'textarea',
    //   key: 'comment',
    //   value: '',
    //   placeholder: '请输入备注',
    //   isNecessary: false
    // },
    {
      title: '年月日',
      type: 'dateForDate',
      key: 'yearMonthDay',
      value: '',
      placeholder: '请选择年月日',
      isNecessary: true
    },
    {
      title: '是否跳过',
      type: 'switch',
      key: 'isSkip',
      value: false,
      placeholder: '请选择是否跳过',
      isNecessary: false
    },
    {
      title: '是否启用',
      type: 'switch',
      key: 'isActive',
      value: false,
      placeholder: '请选择是否启用',
      isNecessary: false
    }
  ]

  // 新增编辑的文字展示
  get addOrUpdateTitle (): string {
    const { id } = this.$route.query
    let res: string = '新增'
    if (id && id !== 'add') {
      res = '编辑'
    }
    return `${res}`
  }

  get treeDataForOrganatizion () {
    return CommonModule.treeDataForOrganatizion
  }

  get treeDataForSubOrganatizion () {
    return CommonModule.treeDataForSubOrganatizion
  }

  get userInfo () {
    return UserModule.userInfo
  }

  async created () {
    await Promise.all([
      CommonModule.getTreeDataForOrganization(),
      CommonModule.getTreeDataForSubOrganization()
    ])
    this.disposeForFillInfoList()
    let { id } = (this as any).$route.query
    if (!id) return (this as any).$router.go(-1)
  }

  // 选择框数据处理
  disposeForFillInfoList () {
    this.fillInfoList = this.fillInfoList.map(item => {
      const { key } = item
      switch (key) {
        case 'type':
          item.selectOptions = this.optionsForType
          break
        case 'subType':
          item.selectOptions = this.optionsForSubType
          break
      }
      return item
    })
  }

  async saveAll () {
    try {
      let whoEmpty = null
      let isEmpty = this.fillInfoList.some(item => {
        if (!item.hide && item.value === '' && item.isNecessary) {
          whoEmpty = item
          return true
        }
      })
      if (isEmpty) return this.$message.warning(whoEmpty.placeholder)
      const params = disposeFillInfoToParamsForCM(this.fillInfoList)
      let { id } = this.$route.query
      if (id && id !== 'add') {
        Object.assign(params, { id })
      }
      const { data: result } = await (this as any).$http.warningConfigAdd(params)
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success(`${this.addOrUpdateTitle}成功`)
      setTimeout(() => {
        this.$router.push({ name: 'EarlyWarningConfig' })
      }, 500)
    } catch (err) {
      console.log(err)
    }
  }

  getFormResultFromChild (result) {
    let { key, value } = result
    this.fillInfoList = this.fillInfoList.map(item => {
      if (item.key === key) {
        switch (key) {
          case 'villagesAndTownsForAddOrUpdateAccompanyMeal':
            item.temporaryStorageForValue = value
            item.value = value.name ? value.name : '- -'
            break
          // 学校：
          case 'organizationNameForAddOrUpdateAccompanyMeal':
            item.temporaryStorageForValue = value
            break
          case 'picture':
            item.imgList.push({
              url: value
            })
            item.value = item.imgList.map(item => item.url).join(',')
            break
          default:
            item.value = value
            break
        }
      }
      return item
    })
  }

  // 拿到多张图片：
  getFormResultForHandleRemoveForPhotoForList (result): void {
    let { key, value } = result
    this.fillInfoList = this.fillInfoList.map(item => {
      if (item.key === key) {
        switch (key) {
          case 'picture':
            item.imgList = value.map(item => {
              return {
                url: item.url
              }
            })
            item.value = item.imgList.map(item => item.url).join(',')
            break
        }
      }
      return item
    })
  }

  operationForButton ({ key }) {
    switch (key) {
      case 'back':
        this.$router.go(-1)
        break
      case 'save':
        this.saveAll()
        break
    }
  }

  getSelectChange (item): void {
    let { key, value } = item
    if (key === 'type') {
      if (value === 4) {
        this.fillInfoList = this.fillInfoList.map(v => {
          if (v.key === 'subType') {
            v.hide = false
          }
          return v
        })
      } else {
        this.fillInfoList = this.fillInfoList.map(v => {
          if (v.key === 'subType') {
            v.hide = true
          }
          return v
        })
      }
    }
  }
}
